import React from "react";
import Metric, {MetricValue} from "./Metric";

const NewIdeasMetric = ({numberOfNewIdeas}) => (
    <Metric label={"New Ideas"}><MetricValue>{numberOfNewIdeas}</MetricValue></Metric>
);

export default NewIdeasMetric;
